'use client';

import { ShoppingCart } from 'lucide-react';
import { useCart } from '@/contexts/CartContext';
import { strobeOnHover } from '@/components/ui/nav-strobe';

interface CartButtonProps {
  onClick?: () => void;
}

export function CartButton({ onClick }: CartButtonProps) {
  const { totalItems } = useCart();

  // Only render if there are items in the cart
  if (totalItems === 0) {
    return null;
  }

  return (
    <div className="inline-flex z-50 relative">
      <button onClick={onClick} className="nav-button nav-strobe inline-flex items-center gap-1.5" {...strobeOnHover}>
        <ShoppingCart className="h-2.5 w-2.5" />
        <span>CART</span>
        <span className="text-[7px] bg-white text-black rounded-full h-3 w-3 flex items-center justify-center font-medium">
          {totalItems}
        </span>
      </button>
    </div>
  );
}
